import { render, staticRenderFns } from "./ExpressOrderCreationAdvancedUser.vue?vue&type=template&id=bda56f8e&scoped=true"
import script from "./ExpressOrderCreationAdvancedUser.vue?vue&type=script&lang=js"
export * from "./ExpressOrderCreationAdvancedUser.vue?vue&type=script&lang=js"
import style0 from "./ExpressOrderCreationAdvancedUser.vue?vue&type=style&index=0&id=bda56f8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda56f8e",
  null
  
)

export default component.exports